module.exports = __webpack_public_path__ + "static/media/test4_3.2f32a9c0.png";